import React from 'react';
interface ClosingSectionProps {
  onAddToCart?: () => void;
}
export function ClosingSection({
  onAddToCart
}: ClosingSectionProps) {
  return <section className="py-20 md:py-32 px-4 relative overflow-hidden" data-id="element-115">
      {/* Background image */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: "url('https://cdn.magicpatterns.com/uploads/3SydJu21MK9kJam6Gs5fpi/Imagen_-_La_glicacion_no_espera.png')"
    }} data-id="element-116"></div>
      {/* Dark overlay for text readability */}
      <div className="absolute inset-0 bg-black/70" data-id="element-117"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-118">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white mb-4 leading-tight" data-id="element-119">
          La glicación no espera.
        </h2>
        <h3 className="text-2xl md:text-3xl font-serif italic text-gold mb-8" data-id="element-120">
          Tu decisión informada empieza hoy.
        </h3>

        <p className="text-lg md:text-xl text-cream/70 font-sans font-light leading-relaxed mb-12 max-w-2xl mx-auto" data-id="element-121">
          Cada día que pasa sin esta información, el proceso sigue avanzando en
          silencio.
        </p>

        <div className="flex flex-col items-center justify-center gap-6" data-id="element-122">
          <a href="https://www.godeskcore.com/cart/42794527916080:1" target="_blank" rel="noopener noreferrer" className="inline-block w-full md:w-auto" onClick={() => onAddToCart?.()} data-id="element-123">
            <button className="w-full md:w-auto bg-cta hover:bg-cta-hover text-white font-bold text-lg md:text-xl py-5 px-10 rounded-lg transition-all duration-300 shadow-[0_4px_20px_0_rgba(200,16,46,0.5)] hover:shadow-[0_6px_30px_rgba(200,16,46,0.4)] hover:-translate-y-1 flex items-center justify-center gap-2" data-id="element-124">
              <span data-id="element-125">🔒 DESCARGAR EBOOK + 3 BONOS — $17.95</span>
            </button>
          </a>

          <p className="text-xs md:text-sm text-cream/50 font-sans" data-id="element-126">
            Acceso inmediato · 4 PDFs descargables · Tuyos para siempre · Pago
            seguro
          </p>

          <div className="flex items-center justify-center gap-4 mt-4 opacity-50 grayscale" data-id="element-127">
            <span className="text-2xl" data-id="element-128">🔒</span>
            <span className="text-2xl" data-id="element-129">💳</span>
            <span className="text-2xl" data-id="element-130">🛡️</span>
          </div>
        </div>
      </div>
    </section>;
}